<ng-container>

    <ng-container *ngIf="useMaterialInput; else innerInput">

        <mat-form-field class="width" [appearance]="appearance" [formGroup]="formGroup">

            <input type="text" matInput formControlName="filter" [matAutocomplete]="auto" (focus)="onFocus($event)"
                (blur)="onBlur($event)" autocomplete="off" (keyup.enter)="onSearchClicked($event)"
                placeholder="z.B. Produktnummer" #input />

            <div matSuffix class="suffix-controls-wrapper">

                <button mat-icon-button @fade matSuffix color="warn" *ngIf="valueControl.value"
                    (click)="clearValue($event)">
                    <mat-icon>clear</mat-icon>
                </button>

            </div>

        </mat-form-field>

    </ng-container>

</ng-container>

<ng-template #innerInput>

    <ng-container [formGroup]="formGroup">

        <input type="text" matInput formControlName="filter" [matAutocomplete]="auto" (focus)="onFocus($event)"
            (blur)="onBlur($event)" autocomplete="off" (keyup.enter)="onSearchClicked($event)"
            placeholder="z.B. Produktnummer" #input />

    </ng-container>

</ng-template>

<mat-autocomplete #auto="matAutocomplete">

    <mat-option *ngFor="let product of products" (click)="setProduct(product)">
        {{displayProduct(product)}}
    </mat-option>

</mat-autocomplete>